import { colors } from "widgets/utils";

import type { SelectionRange } from "../../types.ts";
import { alignToLeftPixelGrid } from "../../utils/graphics/align-to-pixel-grid.ts";

export function rangeSelectionRenderer(
  height: number,
  ctx: CanvasRenderingContext2D | null,
  selectedRange: SelectionRange | undefined,
  basePerPixel: number,
  scrollX: number,
) {
  if (ctx && selectedRange) {
    const startX = alignToLeftPixelGrid(selectedRange.start / basePerPixel - scrollX);
    const stopX = alignToLeftPixelGrid(selectedRange.stop / basePerPixel - scrollX);
    const width = stopX - startX;

    ctx.save();

    ctx.globalAlpha = 0.5;
    ctx.fillStyle = colors.selectedRow;
    ctx.fillRect(startX, 0, width, height);

    ctx.restore();
  }
}
